import { DestroyService } from '@core/services/destroy.service'
import { takeUntil } from 'rxjs/operators'
import { BillingService } from '@shared/services/billing.service'
import { Component, Input } from '@angular/core'

import { BillingQuantities, BillingPricing, BillingQuantitiesFields, BillingPricingFields } from '@shared/models/billing.model'

@Component({
  selector: 'lin-subscription-breakdown-table',
  templateUrl: './subscription-breakdown-table.component.html',
  styleUrls: ['./subscription-breakdown-table.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class SubscriptionBreakdownTableComponent {
  @Input() billingQuantities: BillingQuantities
  @Input() billingPricing: BillingPricing
  @Input() billingPlanId: number
  @Input() editable = false

  activeDevicesExpanded = false
  trackersLoading = false

  activeTrackersFields = ['activeVehicleTrackers', 'activePersonalTrackers', 'activeAssetTrackers', 'activeSatelliteTrackers']
  get activeTrackersTotal(): number {
    return this.activeTrackersFields.reduce(
      (prev, curr) =>
        prev + this.billingQuantities[<string>BillingQuantitiesFields[curr]] * this.billingPricing[<string>BillingPricingFields[curr]],
      0,
    )
  }

  get totalPrice(): number {
    return Object.keys(BillingQuantitiesFields).reduce(
      (prev, curr) =>
        prev +
        this.billingQuantities[<string>BillingQuantitiesFields[curr]] * (this.billingPricing[<string>BillingPricingFields[curr]] || 0),
      0,
    )
  }

  constructor(
    private billingService: BillingService,
    private readonly destroyService: DestroyService,
  ) {}

  saveTrackers(): void {
    this.trackersLoading = true
    this.billingService
      .patchBillingPricing(this.billingPlanId, {
        [BillingPricingFields.activeVehicleTrackers]: this.billingPricing[BillingPricingFields.activeVehicleTrackers],
        [BillingPricingFields.activePersonalTrackers]: this.billingPricing[BillingPricingFields.activePersonalTrackers],
        [BillingPricingFields.activeAssetTrackers]: this.billingPricing[BillingPricingFields.activeAssetTrackers],
        [BillingPricingFields.activeSatelliteTrackers]: this.billingPricing[BillingPricingFields.activeSatelliteTrackers],
      })
      .pipe(takeUntil(this.destroyService))
      .subscribe((): void => {
        this.trackersLoading = false
      })
  }
}
